// @mui
import { GlobalStyles as MUIGlobalStyles } from '@mui/material';

const GlobalStyles = () => {
  const inputGlobalStyles = (
    <MUIGlobalStyles
      styles={{
        '*': {
          boxSizing: 'border-box',
        },
        '#root': {
          height: '100%',
          width: '100%',
        },
        body: {
          height: '100%',
          margin: 0,
          padding: 0,
          width: '100%',
        },
        html: {
          height: '100%',
          margin: 0,
          padding: 0,
          WebkitOverflowScrolling: 'touch',
          width: '100%',
        },
        img: {
          display: 'block',
          maxWidth: '100%',
        },
        input: {
          '&[type=number]': {
            '&::-webkit-inner-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
            '&::-webkit-outer-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
            MozAppearance: 'textfield',
          },
        },
        ul: {
          margin: 0,
          padding: 0,
        },
      }}
    />
  );

  return inputGlobalStyles;
};

export default GlobalStyles;
